import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmErrorComponent } from './sm-error.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [SmErrorComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports:[SmErrorComponent]
})
export class SmErrorModule { }
